import React from 'react';
export const About = () => {
  return <section id="about" className="py-16 w-full" data-id="element-9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10">
        <div className="flex flex-col lg:flex-row items-center" data-id="element-11">
          <div className="lg:w-1/2 mb-10 lg:mb-0 lg:pr-10" data-id="element-12">
            <img src="https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80" alt="极客quant团队" className="rounded-lg shadow-xl w-full" data-id="element-13" />
          </div>
          <div className="lg:w-1/2" data-id="element-14">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-15">
              关于极客quant
            </h2>
            <p className="text-lg text-gray-700 mb-4" data-id="element-16">
              极客quant成立于2018年，是一家专注于量化交易技术研发和策略应用的创新型金融科技公司。我们的团队由来自金融、计算机科学和数学领域的专业人士组成。
            </p>
            <p className="text-lg text-gray-700 mb-4" data-id="element-17">
              我们致力于将尖端的技术应用于金融市场，通过数据挖掘、机器学习和人工智能等技术，开发高效、稳健的量化交易策略，为客户创造持续、稳定的投资回报。
            </p>
            <p className="text-lg text-gray-700 mb-6" data-id="element-18">
              极客quant的核心价值观是诚信、创新和卓越。我们以客户利益为中心，不断探索金融科技的前沿，追求卓越的投资表现。
            </p>
            <div className="grid grid-cols-3 gap-4 text-center" data-id="element-19">
              <div className="bg-blue-50 p-4 rounded-lg" data-id="element-20">
                <div className="text-3xl font-bold text-blue-600 mb-1" data-id="element-21">
                  5年+
                </div>
                <div className="text-sm text-gray-600" data-id="element-22">行业经验</div>
              </div>
              <div className="bg-blue-50 p-4 rounded-lg" data-id="element-23">
                <div className="text-3xl font-bold text-blue-600 mb-1" data-id="element-24">50+</div>
                <div className="text-sm text-gray-600" data-id="element-25">交易策略</div>
              </div>
              <div className="bg-blue-50 p-4 rounded-lg" data-id="element-26">
                <div className="text-3xl font-bold text-blue-600 mb-1" data-id="element-27">
                  200+
                </div>
                <div className="text-sm text-gray-600" data-id="element-28">客户信任</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};